import { render, staticRenderFns } from "./pige_shangpin.vue?vue&type=template&id=43e1a636&"
import script from "./pige_shangpin.vue?vue&type=script&lang=js&"
export * from "./pige_shangpin.vue?vue&type=script&lang=js&"
import style0 from "./pige_shangpin.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports